<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
let isDelete = { "1": "启用", "2": "禁用" };
let type = { "30": "账户消息", "31": "米分变动", "32": "米币变动", "33": "兑换详情" };
let pop = { "1": "否", "2": "是" };
let refreshModel = { "1": "首页", "2": "我的", "3": "兑换（奖品详情）", "4": "米币明细", "5": "米分明细" };
let noticeDisplay = { "1": "否", "2": "是" };
export default {
  name: "innerTemplateMsg",
  components: {
    genericList
  },
  data() {
    return {
      apiUrls: {
        query: URL.templateMsg.query,
        addOrUpdate: URL.templateMsg.addOrUpdate,
        deleteBatchIds: URL.templateMsg.deleteBatchIds,
        status: URL.templateMsg.status
      },
      formCols: [
        { title: '业务编码', field: 'code' },
        { title: '消息类型', field: 'type', type: 2, optionList: type },
        { title: '是否弹窗', field: 'pop', type: 2, optionList: pop },
        { title: '刷新模块', field: 'refreshModel', type: 2, optionList: refreshModel },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete },
        {
          title: '创建时间',
          field: 'time3',
          type: 6,
          format: 'yyyy-MM-dd HH:mm:ss',
          startEndParam: ['createDateBegin', 'createDateEnd']
        },

        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add') }
      ],
      updateCols: [
        { title: 'id', field: 'id', hidden: true },
        { title: '业务编码', field: 'code', required: true },
        { title: '消息类型', field: 'type', type: 2, optionList: type, isNumber: true, required: true },
        { title: '消息标题', field: 'title', maxlength: 50, required: true },
        { title: '消息描述', field: 'remark', maxlength: 50, required: true },
        { title: '消息内容(占位符必须以:{{param}})', field: 'content', type: 6, uploadUrl: URL.detailTask.uploadUrl },
        { title: '系统是否弹窗', field: 'pop', type: 2, optionList: pop, isNumber: true, required: true },
        { title: '刷新模块', field: 'refreshModel', type: 2, optionList: refreshModel, isNumber: true },
        { title: '通知栏是否显示', field: 'noticeDisplay', type: 2, optionList: noticeDisplay, isNumber: true, required: true },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete, isNumber: true, required: true },
      ],
      tableCols: [
        { title: '业务编码', field: 'code' },
        {
          title: '消息类型', field: 'type', render: (data, full) => {
            return type[data];
          }
        },
        { title: '消息标题', field: 'title' },
        { title: '消息描述', field: 'remark' },
        {
          title: '模版内容', field: 'content', minWidth: 200, dangerouslyUseHTMLString: true, render: (data) => {
            return data ? data.replace(/(.{20})/g, '$1<br>') : '';
          }
        },
        {
          title: '是否弹窗', field: 'pop', render: (data, full) => {
            return pop[data];
          }
        },
        {
          title: '通知栏显隐', field: 'noticeDisplay', render: (data, full) => {
            return noticeDisplay[data];
          }
        },
        {
          title: '刷新模块', field: 'refreshModel', render: (data, full) => {
            return refreshModel[data];
          }
        },
        { title: '创建时间', field: 'createDate' },
        { title: '创建人', field: 'createUser' },
        { title: '修改人', field: 'updateUser' },
        { title: '修改时间', field: 'updateDate' },

        {
          field: "isDelete", notice: function (value, row) {
            return (value === '1' || value === 1) ? '启用' : '禁用';
          }, title: "显示/隐藏开关", size: "mini", click: "status", stype: '100', activeText: "启用", inactiveText: "禁用", hidden: "true"
        },
        {
          title: window.$t("business.bt.operation"), minWidth: "180", btnClick: [
            { name: window.$t("business.bt.edit"), click: "update", type: "primary", size: "mini", icon: "el-icon-edit" },
            { name: window.$t("business.bt.delete"), click: "delete", type: "primary", size: "mini", icon: "el-icon-delete" }
          ]
        },
      ]
    };
  }
}
</script>